<script setup>
import { ref } from 'vue';
import OfficeIFrame from './components/OfficeIFrame.vue'
import { onBeforeMount } from 'vue';
import { provide } from 'vue';
import { getUserId } from './utils/auth';
import { setUser } from '@sentry/vue';

const presentationId = ref('');

const isLoading = ref(false);
const editorIframeRef = ref(null);
const isSignUpVisible = ref(false);
const user = ref({});
const isMobile = ref();
const isDocumentLoaded = ref(false);

onBeforeMount(async () => {
  /* const userData = await getUserId();
   * user.value.id = userData.user_id;
   * user.value.is_paid = userData.paid;
   * setUser({ id: user.value.id });
   */
  const parts = window.location.pathname.split('/');
  presentationId.value = parts[parts.length - 1];
  if (presentationId.value === '') {
    presentationId.value = 'aGVsbG8gd29ybGQub2Rw';
  }
});

const setEditorIframeRef = (ref) => {
  editorIframeRef.value = ref;
};

provide('userRef', user);
provide('editorIframeRef', {
  setEditorIframeRef,
  editorIframeRef
});
provide('isMobileRef', isMobile);
provide('isDocumentLoadedRef', isDocumentLoaded);


function toggleIsLoading(state) {
  isLoading.value = state;
}

function requireAuth() {
  isSignUpVisible.value = true;
}

function redirectToSignUp(url) {
  parent.postMessage({
    "MessageId": "Redirect_To_SignUp",
    "SendTime": Date.now(),
    "Values": {},
    "Origin": location.origin,
  }, "*");
}

</script>

<template>
  <main data-theme="light">
    <OfficeIFrame
      v-if="presentationId"
      :file="file"
      :presentationId="presentationId"
      @toggle-loading="toggleIsLoading"
      @require-auth="requireAuth"
    />
    <Dialog v-model:visible="isSignUpVisible" modal :closable="false" :closeOnEscape="false" header="You're Reading a Preview">
      <div class="is-flex is-justify-content-center">
        <span>Unlock full access with sign up</span>
      </div>
      <div class="is-flex is-justify-content-center pt-4">
        <Button class="has-text-weight-bold" style="background-image: radial-gradient(circle at left top, #E100FF, #7F00FF)"
                @click="redirectToSignUp()">
          Sign Up Now
        </Button>
      </div>
    </Dialog>
  </main>
</template>

<style>
 html,
 body {
   margin: 0px;
   padding: 0px;
   border: none;
   overflow-y: hidden;
 }
</style>
